import React from "react";
import PropTypes from "prop-types";
import Attribute from "./Attribute";

const Attributes = ({ attributes }) => {
  return (
    <div className="mt-6">
      {attributes
        .map(
          ([name, value]) =>
            name !== "__typename" && <Attribute name={name} value={value} />,
        )
        .filter((n) => n)}
    </div>
  );
};

Attributes.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default Attributes;
